import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'durationFormat',
    pure: false
})
export class DurationFormatPipe implements PipeTransform {
    transform(value: number, arg1: string, arg2: string): string {
        let days: number;
        let seconds: number;
        let minutes: number;
        let hours: number;

        if (arg1 === 'ms' && arg2 === 'hhmmss') {
            seconds = Math.floor((value / 1000) % 60);
            minutes = Math.floor((value / (1000 * 60)) % 60);
            hours = Math.floor(value / (1000 * 60 * 60));
            return this._format(arg2, seconds, minutes, hours, days);
        } else if (arg1 === 's' && arg2 === 'hhmmss') {
            seconds = Math.floor(value % 60);
            minutes = Math.floor((value / 60) % 60);
            hours = Math.floor(value / 60 / 60);
            return this._format(arg2, seconds, minutes, hours, days);
        } else if (arg1 === 'ms' && (arg2 === 'ddhhmmss' || arg2 === 'ddhhmmssLong')) {
            seconds = Math.floor((value / 1000) % 60);
            minutes = Math.floor((value / (1000 * 60)) % 60);
            hours = Math.floor((value / (1000 * 60 * 60)) % 24);
            days = Math.floor(value / (1000 * 60 * 60 * 24));
            return this._format(arg2, seconds, minutes, hours, days);
        } else if (arg1 === 's' && (arg2 === 'ddhhmmss' || arg2 === 'ddhhmmssLong')) {
            seconds = Math.floor(value % 60);
            minutes = Math.floor((value / 60) % 60);
            hours = Math.floor((value / 60 / 60) % 24);
            days = Math.floor(value / 60 / 60 / 24);
            return this._format(arg2, seconds, minutes, hours, days);
        } else {
            return value.toString();
        }
    }

    private _format(arg2, seconds, minutes, hours, days): string {
        hours < 10 ? (hours = '0' + hours) : hours;
        minutes < 10 ? (minutes = '0' + minutes) : minutes;
        seconds < 10 ? (seconds = '0' + seconds) : seconds;

        switch (arg2) {
            case 'hhmmss':
                return `${hours}:${minutes}:${seconds}`;

            case 'ddhhmmss':
                return `${days}d ${hours}h ${minutes}m ${seconds}s`;

            case 'ddhhmmssLong':
                return `${days} days ${hours} hours ${minutes} minutes ${seconds} seconds`;
        }

        return '';
    }
}
